import actions from './actions';
import mutations from './mutations';

const bonuses = {
    namespaced: true,
    state: {
        driver: {
            items: [],
            pagination: {
                page: 1,
                totalPages: 1
            }
        },
        client: {
            items: [],
            pagination: {
                page: 1,
                totalPages: 1
            }
        }
    },
    mutations,
    actions
};

export default bonuses;
